/**
 * Loads the full plant database on demand (dynamic import) and caches it.
 * Improves initial load: the heavy plantDatabase.js is not parsed until a feature
 * needs it (companion info, shade, pests, calendar, summary table, PDF export).
 */

let cached = null;

/**
 * Returns the full plant database. Loads it on first call, then returns cached.
 * @returns {Promise<Object>} Full plant database keyed by plant name
 */
export async function getPlantDatabase() {
    if (cached) return cached;
    const module = await import('./plantDatabase.js');
    cached = module.default;
    return cached;
}
